/**
 * Created by pandemio on 9/27/18.
 */
import LanguageManager from '../custom-classes/language-manager';
import BackgroundImg from '../img/logo.png';

/**
 * Custom class to manage the exam results
 */
class ResultsToHTMLConverter{

    /**
     * Returns the results in HTML format. If you want to edit the "PDF" here is your place to edit
     * @param dataReturned The data returned from the web service
     * @param courseName The coursename
     * @param studentName The student name
     * @param languages The languages that the app supports
     * @returns {string} Returns a string of the results in a HTML format ready to be printed
     */
     static getHtmlResults(dataReturned, studentName, languages){

         let transTotalPercent = LanguageManager.getTranslation("report-student-average.total", languages);
         let transTry = LanguageManager.getTranslation("report-student-average.try", languages);
         let transLevelOfKnowledge = LanguageManager.getTranslation("report-student-average.dok", languages);
         let transStudentResponse = LanguageManager.getTranslation("report-student-average.student-answer", languages);
         let transCorrect = LanguageManager.getTranslation("report-student-average.correct", languages);
         let transIncorrect = LanguageManager.getTranslation("report-student-average.incorrect", languages);
         let transQuestion = LanguageManager.getTranslation("report-student-average.question", languages);

         // Create the HTML
         let htmlToAdd = "<div style='font-family:sans-serif;background-image:{BackgroundImg}'>";
         htmlToAdd += "<h4>" + dataReturned.QuizTitle + "</h4>";
         htmlToAdd += "<h4><i>" + studentName + "</i></h4>";
         htmlToAdd += "<hr>";
         htmlToAdd += "<h5>" + transTotalPercent + ": " + dataReturned.TotalPercent + "%</h5>";
         htmlToAdd += "<h5>" + transTry + ": " + dataReturned.TryNo  +"</h5>";
         htmlToAdd += "<h5>" + transLevelOfKnowledge +": " + dataReturned.DoK + "</h5>";
         htmlToAdd += "<hr>";

         for(var i=0; i < dataReturned.QuestionQuizList.length;i++) {
             htmlToAdd += "<hr>";
             htmlToAdd += "<p>";
             htmlToAdd += "<b>" + (i + 1).toString() + ") " + transQuestion + ": </b>";
             htmlToAdd += "<i>" + dataReturned.QuestionQuizList[i].Question + "</i>";
             htmlToAdd += "<p>";
             htmlToAdd += transStudentResponse + ": ";
             htmlToAdd += "<i>" + dataReturned.QuestionQuizList[i].QuestionResponses[0].Response + "</i>";
             htmlToAdd += "<p>";
             if (dataReturned.QuestionQuizList[i].QuestionResponses[0].Correct)
                 htmlToAdd += "<b style='color:green'>" + transCorrect + "</b>";
             else
                 htmlToAdd += "<b style='color:red'>" + transIncorrect + "</b>";
         }
         htmlToAdd += "</div>";
         return htmlToAdd;
     }
}

export default ResultsToHTMLConverter;


// WEBPACK FOOTER //
// ./src/custom-classes/results-html-converter.js